module.exports = __webpack_public_path__ + "img/zwischenzeiten10.f83132a4.jpg";